module.exports = __webpack_public_path__ + "img/1562574409.d22fc806.jpg";